import { Icon } from "./Icon";

/* "Did the same car you booked come?" and "Did the same driver you booked come?" -
   asked with the stars on every rating form (a car's page, a hire driver's page, the
   enquiry page and the home lists' recent-enquiry card), so all of them ask alike.

   One tap each, Yes or No, and a tap on the chosen one takes it back: either can be
   left unanswered. `rate` is hooks/useLeadRating's result, which knows what to ask - a
   hire only about the driver, and nothing after "I did not book". The answers go with
   the stars and are counted into the car's rating, for other customers to see.
   hide: the enquiry page's own "did not book", which the hook may not have yet. */
export default function RatingMatchQuestions({ t, rate, hide = false }) {
  if (hide || !rate?.asks) return null;
  const rows = [
    rate.asks.car && { key: "car", icon: "car", q: t("rm_sameCar"), value: rate.sameCar, set: rate.setSameCar },
    rate.asks.driver && { key: "driver", icon: "user", q: t("rm_sameDriver"), value: rate.sameDriver, set: rate.setSameDriver },
  ].filter(Boolean);
  if (!rows.length) return null;
  return (
    <div className="mt-2.5 space-y-2">
      {rows.map((r) => (
        <div key={r.key} role="radiogroup" aria-label={r.q}>
          <p className="flex items-start gap-1.5 text-[11px] font-bold text-[#1F2937] leading-snug">
            <Icon name={r.icon} size={14} stroke="#5E8700" strokeWidth={2} className="shrink-0 mt-px" />
            <span className="min-w-0">{r.q}</span>
          </p>
          <div className="mt-1 flex gap-2">
            {[[true, "rm_yes"], [false, "rm_no"]].map(([v, key]) => {
              const on = r.value === v;
              const tone = !on ? "bg-white border-[#E5E7EB] text-[#334155]"
                : v ? "bg-[#F1F7E3] border-[#7BAE00] text-[#3F5E00]" : "bg-[#FEF2F2] border-[#FCA5A5] text-[#B91C1C]";
              return (
                <button key={key} type="button" role="radio" aria-checked={on} onClick={() => r.set(on ? null : v)}
                  className={`flex-1 min-h-[40px] rounded-[11px] border text-[11.5px] font-bold flex items-center justify-center gap-1 active:scale-[0.98] ${tone}`}>
                  {on && <Icon name={v ? "check" : "x"} size={13} strokeWidth={2.6} />}
                  {t(key)}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
